<template>
    <div>
        <div class="designeroption" id="frame_style" :data-designer-component-id="component_id">
            <h3>Side panels</h3>
            <div class="activatepanels">
                <div class="txt">
                    <p>Select your frame configuration by clicking on the plus on the sidepanel and top box areas.</p>
                    <p>Once you select a sidepanel further options will be available.</p>
                </div>
                <div class="options">
                    <div class="topbox">
                        <input type="checkbox" value="top" v-model="localTarget.checkedPanels"/>
                    </div>
                    <div class="sidepanels">
                        <input type="checkbox" value="left" v-model="localTarget.checkedPanels" />
                        <img :src="activate_panels_img_src" alt="" class="doorimg"/>
                        <input type="checkbox" value="right" v-model="localTarget.checkedPanels"/>
                    </div>
                </div>
            </div>
        </div>

        <div class="designeroption">
        <designer-question-frame-style :fabricator="fabricator" :type-range="typeRange" :title="title" v-model:target="localTarget.frame_id" :checked-panels="localTarget.checkedPanels">

        </designer-question-frame-style>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import DesignerQuestionFrameStyle from "./DesignerQuestionFrameStyle.vue";
    import {nextTick} from "vue";

    export default {
        components: {
            DesignerQuestionFrameStyle,
        },
        emits: ['update:target'],
        computed: {
            localTarget: {
                get(){
                    return this.target;
                },
                set(new_val){
                    this.$emit('update:target', new_val);
                }
            }
        },
        props:{
            title: {
                default(){
                    return 'Select Frame Style';
                }
            },
            component_id: {
                default(){
                    return 'side_panels';
                }
            },
            fabricator: {
                required: true,
            },
            typeRange: {
              required: false,
              default(){
                return 0;
              }
            },
            target: {
                required: true,
                type: Object,
                default(){
                    return {
                        frame_id: 1,
                        checkedPanels: [],
                    };
                }
            },
            floating_sidebar_message: {
                default() {
                    return '';
                }
            },
            activate_panels_img_src: {
                default() {
                    return '/images/activatepanelsimg.jpg';
                }
            }
        },
        mounted() {
            $('#frame_style input').iCheck({
                checkboxClass: 'checkboxstyle',
                radioClass: 'radiostyle',
                selectClass: 'selectstyle'
            });

            $('#frame_style input').on('ifChecked', (e) => {
                this.localTarget.checkedPanels.push(e.target.value);
                this.syncICheck();
            });

            $('#frame_style input').on('ifUnchecked', (e) => {
                window._.pull(this.localTarget.checkedPanels, e.target.value);
                this.localTarget.checkedPanels = JSON.parse(JSON.stringify(this.localTarget.checkedPanels));
                this.syncICheck();
            });

            window.emitter.on('reset-button-clicked', () => {
                this.syncICheck();
            });

            window.emitter.on('range-updated', () => {
                this.syncICheck();
            });

        },
        onUnmounted() {
            window.emitter.off('reset-button-clicked');
            window.emitter.off('range-updated');
        },
        methods: {
            sideIsChecked(side){
                return this.localTarget.checkedPanels.includes(side);
            },
            syncICheck: function () {
                nextTick(() => {
                    let frameStyle = $('#frame_style');

                    let options = [
                        frameStyle.find('input[value="left"]'),
                        frameStyle.find('input[value="right"]'),
                        frameStyle.find('input[value="top"]'),
                    ];

                    options.forEach((panel) => {
                        let isChecked = this.sideIsChecked(panel.val());
                        panel.prop('checked', isChecked);
                        panel.iCheck('update');
                    });
                });
            }
        },
    }
</script>
